export const GROUP_DOMAIN_RESTRICTIONS = {
  IUSMEV: ['iu.edu'],
};
